import * as React from 'react'

import { clsx } from 'clsx'

import styles from './PageNotices.module.css'

type PageNoticesProps = React.HTMLAttributes<HTMLDivElement>

const PageNotices = React.forwardRef<HTMLDivElement, PageNoticesProps>(
  ({ children, className, ...props }, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={clsx(styles.notices, className)}
      {...props}
    >
      {children}
    </div>
  ),
)

PageNotices.displayName = 'PageNotices'

const StickyPageNotice = React.forwardRef<HTMLDivElement, PageNoticesProps>(
  ({ children, className, ...props }, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={clsx(styles.stickyNotice, className)}
      {...props}
    >
      {children}
    </div>
  ),
)

StickyPageNotice.displayName = 'StickyPageNotice'

export { PageNotices, StickyPageNotice }
export type { PageNoticesProps }
